export default __webpack_public_path__ + "static/media/tianmao2.7a0c9414.jpg";